<template>
  <div id="aboutUs">
    <div class="head_wrapper">
      <div class="head_cover"></div>
      <div class="noAgent">
        不收代理费
      </div>
      <div class="weightFee">
        进口按重量收运费 5.8 元/公斤
      </div>
      <div class="head_cover" style="opacity: 0.1;"></div>
    </div>
    <van-tabs ref="tabs" :before-change="beforeChange" line-width="16px" v-model="activedIndex" :ellipsis="ellipsis"
      sticky scrollspy @scroll="scrollContent">
      <van-tab title="关于公司">
        <div class="content_wrapper">
          <div class="content_box about_company">
            <div class="content_title" style="width:64px">关于公司</div>
            <div class="content_detail">
              <div class="content_detail_item" style="font-weight:400">
                深圳市正能量供应链服务有限公司，隶属于正能量旗下。
              </div>
              <div class="content_detail_item" style="font-weight:400">
                公司专注电子元器件的进口报关、供应链金融、香港仓储/代收发货、香港理货、ESCROW等。
              </div>
              <div class="content_detail_item" style="font-weight:400">
                累计服务超<span class="main_color">5000</span>家客户，月均处理订单<span
                  class="main_color">5000+</span>，目前年交易总额（GMV）达到<span class="main_color">40</span>亿。
              </div>
            </div>

            <van-swipe :loop="false" :width="296" style="margin-top:28px;padding-bottom:22px">
              <van-swipe-item v-for="(image, index) in getImages(0, false)" :key="index">
                <div style="height:160px" @click="lookSwipeImage(getImages(0, false))">
                  <img v-lazy="image" height="100%" width="281" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </van-tab>
      <van-tab title="1.进口报关">
        <div class="content_wrapper">
          <div class="content_box about_company">
            <div class="content_title" style="width:80px">1.进口报关</div>
            <div class="content_detail">
              <div class="content_detail_title">电子元器件进口报关，首选正能量供应链</div>
              <div class="content_detail_item mg4">
                正规安全
              </div>
              <div class="content_detail_item_content">
                正能量网络十年深耕，坚持长期主义守住本份。不涉金融，不搞地产，无杠杆，不负债经营，不强调利润，不刻意追求规模，坚守为元器件贸易商服务的初心。
              </div>
              <div class="content_detail_item mg4">
                成本低廉
              </div>
              <div class="content_detail_item_content">
                不收代理费，仅按重量收费。相较于传统供应链公司按货值千分之三收取代理费，电子元器件通过正能量供应链进口报关，费用成本降低88.73%（货值6.8万USD/重量5.5KG）。
              </div>
              <div class="content_detail_item mg4">
                阳光透明
              </div>
              <div class="content_detail_item_content">
                在线下单，收费公开透明，无隐式费用，自助对账，笔笔清晰。
              </div>
              <div class="charge_warpper">
                收费标准：<div class="content_detail_title" style="margin-bottom:0">单证费150元/单 + 5.8元RMB/KG</div>
              </div>
            </div>

            <van-swipe :loop="false" :width="296" style="margin-top:28px;padding-bottom:22px">
              <van-swipe-item v-for="(image, index) in getImages(1, false)" :key="index">
                <div style="height:160px" @click="lookSwipeImage(getImages(1, false))">
                  <img v-lazy="image" height="100%" width="281" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </van-tab>
      <van-tab title="2.香港仓储">
        <div class="content_wrapper">
          <div class="content_box about_company">
            <div class="content_title" style="width:80px">2.香港仓储</div>
            <div class="content_detail">
              <div class="content_detail_title">20000呎香港自营仓库，可长租，可短租，小至卡板，大至千平</div>
              <div class="content_detail_item mg4">
                安防体系
              </div>
              <div class="content_detail_item_content">
                7x24小时CCTV监控，配备红外探测及门磁感应系统，并与香港警方认可的第三方报警系统联网。
              </div>
              <div class="content_detail_item mg4">
                货物保险
              </div>
              <div class="content_detail_item_content">
                已投保财产险及盗窃险，出险后由保险公司赔付。
              </div>
              <div class="content_detail_item mg4">
                运营团队
              </div>
              <div class="content_detail_item_content">
                核心人员拥有十年以上电子元器件仓库操作经验，全员执行标准化作业流程。
              </div>
              <div class="charge_warpper">
                收费标准：<div class="content_detail_title" style="margin-bottom:0">5HKD/箱/天、15HKD/板/天</div>
              </div>
            </div>

            <van-swipe :loop="false" :width="296" style="margin-top:28px;padding-bottom:22px">
              <van-swipe-item v-for="(image, index) in getImages(2, false)" :key="index">
                <div style="height:160px" @click="lookSwipeImage(getImages(2, false))">
                  <img v-lazy="image" height="100%" width="281" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </van-tab>
      <van-tab title="3.香港代收/发货">
        <div class="content_wrapper">
          <div class="content_box about_company">
            <div class="content_title" style="width:130px">3.香港代收/发货</div>
            <div class="content_detail">
              <div class="content_detail_title">为电子元器件外贸商/代理商/终端客户提供一站式香港港代收货、代发货服务。</div>

              <div style="display:flex;justify-content: space-between;flex-wrap:wrap;margin-bottom: 12px;">
                <div class="content_detail_item" style="width:45%">
                  无入仓登记费
                </div>
                <div class="content_detail_item" style="width:45%">
                  可代清关
                </div>
                <div class="content_detail_item mt4" style="width:45%">
                  专属提货/送货司机
                </div>
                <div class="content_detail_item mt4" style="width:45%">
                  可代发国际快递
                </div>
              </div>

              <div class="charge_warpper">
                收费标准：<div class="content_detail_title" style="margin-bottom:0">100HKD/次 （入/出仓）</div>
              </div>

              <div style="margin-top:16px">
                <div class="content_detail_item_content mb0">
                  <span class="f666">公司名称：</span>正能量物流香港公司
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">地址： </span>香港九龙观塘大业街35号福和工业大厦6楼A2室 （走B座电梯）
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">联系人：</span>赵丽云
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">电话：</span>852-35292686,96025831
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">传真：</span>35292687
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">工作时间：</span>周一至周五：上午9:00-12:30 下午1:30-6:00 周六：上午9:00-12:30 （香港公众假期除外）
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">香港邮政编码：</span>999077
                </div>
              </div>

              <div style="margin-top:16px;word-break:break-all;">
                <div class="content_detail_item_content mb0">
                  <span class="f666">Company name：</span>BOM.AI LOGISTICS HONG KONG LIMITED
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">ADDRESS：</span>A2,6/F,Fortune Industrial Building,35 Tai YipStreet,Kwun
                  Tong,Kowloon,Hong Kong
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">Attn：</span>LI Yun Zhao
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">Tel：</span>852-35292686,96025831
                </div>
                <div class="content_detail_item_content mb0">
                  <span class="f666">Fax：</span>35292687
                </div>
                <!-- <div class="content_detail_item_content mb0">
                  工作时间：周一至周五：上午9:00-12:30 下午1:30-6:00 周六：上午9:00-12:30 （香港公众假期除外）
                </div> -->
              </div>
            </div>

            <van-swipe :loop="false" :width="296" style="margin-top:28px;padding-bottom:22px">
              <van-swipe-item v-for="(image, index) in getImages(3, false)" :key="index">
                <div style="height:160px;width: 281px;" @click="lookSwipeImage(getImages(3, false))">
                  <img v-lazy="image" height="100%" width="100%" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </van-tab>
      <van-tab title="4.香港理货">
        <div class="content_wrapper">
          <div class="content_box about_company">
            <div class="content_title" style="width:80px">4.香港理货</div>
            <div class="content_detail">
              <div class="content_detail_title">为电子元器件统货/订货/外贸客户提供个性化的香港理货服务。</div>
              <div class="content_detail_item mg4">
                服务
              </div>
              <div class="content_detail_item_content">
                丝印拍照、QC拍照、贴/撕/定制标签、抽真空袋、更换包装、分货/点货、拆/合包、代发快递等
              </div>
              <div class="content_detail_item mg4">
                收费标准
              </div>

              <div style="padding-right:8px" @click="lookChargeImage">
                <img src="@/assets/img/charge.png" width="100%" height="100%" />
                <div class="lookBigP">（点击查看大图）</div>
              </div>

            </div>

            <van-swipe :loop="false" :width="296" style="margin-top:28px;padding-bottom:22px">
              <van-swipe-item v-for="(image, index) in getImages(4, false)" :key="index">
                <div style="height:160px" @click="lookSwipeImage(getImages(4, false))">
                  <img v-lazy="image" height="100%" width="281" />
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <van-dialog v-model="consultDlg" title="业务咨询" class="consultDlg-982j3k">
      <span>客服QQ：</span>
      <a>3008552851</a><br />
      <span>客服热线1：</span><a href="tel:075583250835">0755-83250835</a><br />
      <span>客服热线2：</span><a href="tel:15914106963">15914106963</a> (微信同号)<br />
      <span>客服热线3：</span><a href="tel:15999590322">15999590322</a><br />
      <div class="work-day">周一至周五(9:00-12:00 13:30-18:30)，节假日除外。</div>
    </van-dialog>

    <div class="fixedBtn_wrapper">
      <!-- <div>
        业务咨询：<br/>
        QQ:
        <a data-v-52f7bd6f="" target="_blank"
          href="//wpa.qq.com/msgrd?v=3&amp;uin=3008552851&amp;site=qq&amp;menu=yes">3008552851</a>

        电话：<a href="tel:075583250835">0755-83250835</a>、
        <a href="tel:15914106963">15914106963</a> (微信同号)
      </div> -->

      <div class="orderBtn_bg" @click="consultDlg = true">咨询</div>
      <div class="orderBtn_bg r" @click="onEdit">现在下单</div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Toast } from "vant";
import { ImagePreview } from 'vant';
const IMGS = [
  "p-0-1", "p-0-2", "p-1-1", "p-1-2", "p-1-21", "p-1-3", "p-1-4", "p-2-14", "p-2-15", "p-2-16", "p-2-17", "p-2-18", "p-2-19", "p-2-20", "p-3-10", "p-3-11", "p-3-12", "p-3-13", "p-3-4", "p-4-4", "p-4-5", "p-4-6", "p-4-7", "p-4-8", "p-4-9",
];

export default {
  name: "aboutUs",
  components: {
  },
  data() {
    return {
      ellipsis: false,
      activedIndex: 0,
      isBottom: false,
      lastPos: 0,
      consultDlg: false
    };
  },
  computed: {

  },
  methods: {
    getImages(pId, isThumbnail) {
      const pfxName = `p-${pId}`;
      const endName = isThumbnail ? "-s.jpg" : ".jpg";
      return IMGS.filter((e) => e.startsWith(pfxName)).map(
        (e) => `https://cdn.znlscm.com/imgs/ghome/${e}${endName}`
      );
    },

    lookChargeImage() {
      let imageURL = require("../../assets/img/charge.png");
      ImagePreview([imageURL]);
    },

    lookSwipeImage(urls) {
      ImagePreview(urls);
    },

    onEdit() {
      if (this.$store.state.user.data != null) {
        this.$router.push("/");
      } else {
        this.$router.push({
          name: 'Login',
        });
      }
    },
    showConsult() {
      this.$dialog.alert({ message: "<div>咨询电话：0755-83250835</div><div>咨询QQ：3008552851</div>", title: "业务咨询", allowHtml: true })
    },
    scrollContent(e) {
      let difPos = e.scrollTop - this.lastPos;
      if (Math.abs(difPos) <= 5) {
        this.lastPos = e.scrollTop
        return;
      }

      if (e.scrollTop >= this.$el.clientHeight - document.documentElement.clientHeight - 50) {
        this.isBottom = true;
        setTimeout(() => {
          this.activedIndex = 4
        }, 100);
      } else {
        this.isBottom = false;
      }
      this.lastPos = e.scrollTop
    },

    beforeChange(index) {
      // 返回 false 表示阻止此次切换
      if (this.isBottom) {
        return false;
      }
    },
  },

  async created() {
  },
};
</script>
<style lang="less" scoped>
#aboutUs {
  font-family: PingFang SC-Medium, PingFang SC;
  background: #F7F8FA;
  padding-bottom: 62px;

  .head_wrapper {
    width: 100%;
    height: 120px;
    background: url("../../assets/img/loginbanner.webp");
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    letter-spacing: 2px;

    .noAgent {
      position: absolute;
      left: 16px;
      top: 38px;
      height: 28px;
      font-size: 26px;
      color: #fff;
      font-weight: bold;
      line-height: 28px;
    }

    .weightFee {
      position: absolute;
      left: 16px;
      top: 66px;
      height: 15px;
      font-size: 11px;
      color: #fff;
      font-weight: 500;
    }

    .head_cover {
      background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.5;
    }
  }

  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 40px;

    .van-tabs__nav--line {
      height: 40px;
      padding: 0;
      padding-left: 8px;
      box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0.1);

      .van-tab {
        padding: 0 8px;
        margin-right: 8px;
        color: rgba(0, 0, 0, 0.5);
        font-weight: 400;
        font-size: 14px;
      }

      .van-tab--active {
        color: rgba(0, 0, 0, 0.9);
        font-weight: 500;
      }

      .van-tabs__line {
        background-color: #ee7700;
        height: 4px;
        bottom: 0;
      }
    }
  }

  .content_wrapper {
    padding: 5px 8px;

    .content_box {
      background-color: #fff;
      width: 100%;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px 4px 4px 4px;

      .content_title {
        height: 20px;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        line-height: 20px;
        position: relative;
        margin-bottom: 8px;
        z-index: 0;
      }

      .content_title::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        background: linear-gradient(90deg, rgba(238, 119, 0, 0.5) 0%, rgba(238, 119, 0, 0) 100%);
        height: 6px;
        z-index: -1;
      }

      .content_detail {
        margin-top: 8px;

        .content_detail_title {
          line-height: 20px;
          min-height: 20px;
          margin-bottom: 16px;
          color: #EE7700;
          font-weight: 700;
          font-size: 14px;
          padding-right: 8px;
        }

        .content_detail_item {
          font-weight: 700;
          color: #333333;
          font-size: 12px;
          letter-spacing: 1px;
          margin-left: 14px;
          position: relative;
          min-height: 20px;
          margin-bottom: 8px;
          line-height: 20px;
          padding-right: 8px;
          text-align: justify;
        }

        .content_detail_item::after {
          content: "";
          display: block;
          position: absolute;
          left: -14px;
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background-color: #ee7700;
          top: 6px;
        }

        .content_detail_item_content {
          line-height: 20px;
          color: #1A1A1A;
          font-weight: 400;
          font-size: 12px;
          margin-bottom: 20px;
          padding-right: 8px;
          text-align: justify;
        }

        .main_color {
          color: #ee7700;
          font-weight: bold;
        }

        .charge_warpper {
          width: calc(100% - 8px);
          height: 40px;
          border: 1px solid #E5E6EB;
          border-radius: 4px 4px 4px 4px;
          background: #F7F8FA;
          padding: 10px 12px;
          color: #333333;
          display: flex;
          align-items: center;
        }

        .lookBigP {

          line-height: 20px;
          height: 20px;
          font-weight: 400;
          color: #666666;
          font-size: 12px;
          text-align: center;
        }
      }

      ::v-deep .van-swipe__indicators {
        bottom: 8px;

        .van-swipe__indicator {
          opacity: 1;
          background: #E5E6EB;
        }

        .van-swipe__indicator--active {
          background-color: #ee7700;
        }
      }
    }

    .about_company {
      padding: 16px 0 8px 8px;

    }
  }

  .mg4 {
    margin-bottom: 4px !important;
  }

  .mt4 {
    margin-top: 4px !important;
  }

  .mb0 {
    margin-bottom: 0 !important;
  }

  .f666 {
    color: #666;
  }

  .fixedBtn_wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    width: 100%;
    box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.15);
    gap: 5px;

    .orderBtn_bg {
      width: 351px;
      height: 48px;
      background: url("../../assets/img/orderBtn.webp");
      background-size: 351px 50px;
      background-repeat: no-repeat;
      line-height: 48px;
      color: #fff;
      text-align: center;
      font-size: 17px;
    }

    .r {
      background-position-x: right;
    }
  }
}
</style>

<style lang="scss">
.consultDlg-982j3k {
  .van-dialog__content {
    padding: 0.5em 1em;
    font-weight: normal;
    color: #333;
    font-size: 14px;
    line-height: 2em;

    span {
      width: 6em;
      display: inline-block;
      text-align: right;
    }
  }

  .work-day {
    border-top: 1px dotted #333;
    margin-top: 0.5em;
    padding-top: 0.5em;
    font-size: 12px;
    text-align: center;
  }

  a {
    color: dodgerblue;
  }

}
</style>